import React from 'react'

function SummaryRow({ label, value }) {
  return (
    <div
    className="d-flex justify-content-between align-items-start mb-2 gap-2 flex-wrap"
  >
    <span className="text-nowrap">{label}</span>
    <span className="fw-medium" style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>{value}</span>
  </div>
  )
}

export default SummaryRow

